import gsap from 'gsap'
import {headerClass, loginPopupClass, searchClass, isAllMobileDevices, barba, colors} from './bundle'

let instance = null
class Menu{
    constructor(){
        //singleton
        if(instance){
            return instance
        }
        instance = this
        this.popupActions = document.querySelector('.popup-actions')
        this.allPopups = [...this.popupActions.querySelectorAll('.popup-actions__item')]
        this.popupActionsBackground = this.popupActions.querySelector('.popup-actions__bg')
        this.popupActionsOverlay = this.popupActions.querySelector('.overlay')
        // console.log(this)
        this.menu = document.querySelector('.main-menu')
        this.menuWrapper = document.querySelector('.menu__wrapper')
        this.menuItemsWithPrevent = [...document.querySelectorAll('.menu-with-prevent .menu-item')]
        this.submenus = [...document.querySelectorAll('.right .submenu')]

        this.hamburgers = document.querySelectorAll('.hamburger')
        this.closeMenuBtns = [...document.querySelectorAll('.close-menu')]
        this.caliceObj = { m1: 0, m2: 25, c1: 30, c2: 50, c3: 70, c4: 50, c5: 100, c6: 25}
        this.svgCalice = document.querySelectorAll('.svg-calice')
        this.vinoNelCaliceObj = { m1: 5, m2: 25, c1: 30, c2: 45, c3: 70, c4: 45, c5: 95, c6: 25}
        this.svgVinoNelCalice = document.querySelectorAll('.svg-vino')
        this.gamboObj = { m1: 50, m2: 50, v1: 50}
        this.svgGambo = document.querySelectorAll('.svg-gambo')            


        //Mobile
        this.containerMobileMenus = document.querySelector('.container-mobile-menus')
        this.containerHamburgerFake = this.containerMobileMenus.querySelector('.container-mobile-menus__hamburger-fake')
        this.mobileMenusHeader = this.containerMobileMenus.querySelector('.container-mobile-menus__header')
        this.menuImtemsMobile = this.containerMobileMenus.querySelectorAll('.menu-item-mobile')

        this.mainMenuBackground = this.containerMobileMenus.querySelector('.menu-mobile__bg span')
        this.closeMainMenuMobileBtns = this.containerMobileMenus.querySelectorAll('.btn-close-main-menu-mobile')
        
        this.mainMenu = this.containerMobileMenus.querySelector('.menu-mobile--main-menu')
        this.vociMenuMobile = this.mainMenu.querySelectorAll('.menu-item-mobile')
        this.mainMenuMobileWrapper = this.mainMenu.querySelector('.menu-mobile__wrapper')
        
        this.containerSubmenus = this.containerMobileMenus.querySelector('.container-submenus')
        this.submenuBackground = this.containerSubmenus.querySelector('.submenu-mobile__bg span')
        this.closeSubmenuMobileBtns = this.containerSubmenus.querySelectorAll('.btn-close-submenu-mobile')
        this.allSubmenusMobile = this.containerSubmenus.querySelectorAll('.submenu-mobile')


        //Bool
        this.isAnimating = false
        this.initEvents()
    }

    initEvents(){
        // console.log(detectedDevice.isBigTablet())
        // window.addEventListener('orientationchange', () => {

        //     this.hamburgers.forEach(ham => {
        //         ham.removeEventListener('click')
        //     })
        //     // inserisco LANDSCAPE perchè l'orientamento viene rilevato PRIMA di ruotare
        //     if(detectedDevice.isBigTablet() === 'landscape'){
        //         this.clickHamburgerMobile()
        //     }
        //     else{
        //         this.clickHamburger()
        //     }
        // })
        // if(detectedDevice.isMobile() || detectedDevice.isSmallTablet() || detectedDevice.isBigTablet() === 'portrait'){
        //     this.clickHamburgerMobile()
        // }
        // else{
        //     this.clickHamburger()
        // }

        // if(!isAllMobileDevices){
        //     this.hoverHamburger()
        //     // this.clickHamburger()
        // }
        // else{
        //     // this.clickHamburgerMobile()
            
        // }


        // if(screen.width <= 767 || screen.width >= 744 && screen.width <= 834 || screen.width === 1024){
        if(screen.width > 834 && screen.width !== 1024){
            this.hoverHamburger()
        }

        this.clickHamburger()
        /**
         * DESKTOP
         */
        this.clickItemMenu()
        this.closeMenuBtns.forEach(closeBtn => {
            closeBtn.addEventListener('click', () => {            
                this.closeHamburgerIcon()
                this.closeMenu()
            })
        })

        /**
         * MOBILE
         */
        this.vociMenuMobile.forEach( voceMenuMobile => {
            voceMenuMobile.addEventListener('click', () => {
                if(this.isAnimating) return
                this.isAnimating = true                    
                let qualeSubmenu = voceMenuMobile.getAttribute('data-submenu')
                this.openSubmenuMobile(qualeSubmenu)
            })
        })        
        this.closeMainMenuMobileBtns.forEach(closeBtn => {
            closeBtn.addEventListener('click', () => {    
                if(this.isAnimating) return
                this.isAnimating = true           
                this.closeMenuMobile()
            })
        })
        this.closeSubmenuMobileBtns.forEach(closeBtn => {
            closeBtn.addEventListener('click', () => {  
                if(this.isAnimating) return
                this.isAnimating = true             
                this.closeSubmenuMobile()
            })
        })

    }

    setZindex(){
        gsap.set(this.menu,{
            'z-index': 7
        })
        this.allPopups.forEach( popup => {
            if(!popup.isSameNode(this.menu)){
                gsap.set(popup,{
                    'z-index': 3
                })
            }
        })

    }
    clickHamburger(){
        this.hamburgers.forEach(ham => {
            ham.addEventListener('click', () => {
                if(this.isAnimating) return
                this.isAnimating = true
                // if(!isAllMobileDevices){
                // if(isAllMobileDevices){
                // alert(screen.width)
                if(screen.width > 834 && screen.width !== 1024){
                    //apro menu
                    if (!ham.classList.contains('opened')) {
                        //se NON ci sono altri popup aperti
                        if(document.querySelector('.popup-active') !== null){
                            const dataOtherPopup = document.querySelector('.popup-active').getAttribute('data-popup-element')
                            if(dataOtherPopup === 'login'){
                                loginPopupClass.closeLoginPopup('menu').then( () => {
                                    this.openMenu()
                                })
                            }
                            else if(dataOtherPopup === 'search'){
                                searchClass.closeSearch('menu').then( () => {
                                    this.openMenu()
                                })
                            }
                        }
                        //se ci sono altri popup aperti
                        else{
                            gsap.set(this.popupActions,{
                                y: '0%'
                            })
                            this.openMenu()
        
                        }
                    }
                    //chiudo menu
                    else {
                        // console.log('clicco hamburger e chiudo')
                        this.closeMenu()
                    }
                }
                else{
                    //apro menu mobile
                    if (!ham.classList.contains('opened')) {
                        if(document.querySelector('.popup-active') !== null){
                            const dataOtherPopup = document.querySelector('.popup-active').getAttribute('data-popup-element')
                            if(dataOtherPopup === 'login'){
                                loginPopupClass.closeLoginPopup().then( () => {
                                    this.openMenuMobile()
                                })
                            }
                            else if(dataOtherPopup === 'search'){
                                searchClass.closeSearch().then( () => {
                                    this.openMenuMobile()
                                })
                            }
                        }
                        else{
                            this.openMenuMobile()
                        }
                    
                    }
                    //chiudo menu mobile
                    else {
                        this.closeMenuMobile()
                    }
    
                }
            })
    
        })
    }    
    // clickHamburger(){
    //     this.hamburgers.forEach(ham => {
    //         ham.addEventListener('click', () => {
    //             if(this.isAnimating) return
    //             this.isAnimating = true
    //             //apro menu
    //             if (!ham.classList.contains('opened')) {
    //                 //se NON ci sono altri popup aperti
    //                 if(document.querySelector('.popup-active') !== null){
    //                     const dataOtherPopup = document.querySelector('.popup-active').getAttribute('data-popup-element')
    //                     if(dataOtherPopup === 'login'){
    //                         loginPopupClass.closeLoginPopup('menu').then( () => {
    //                             this.openMenu()
    //                         })
    //                     }
    //                     else if(dataOtherPopup === 'search'){
    //                         searchClass.closeSearch('menu').then( () => {
    //                             this.openMenu()
    //                         })
    //                     }
    //                 }
    //                 //se ci sono altri popup aperti
    //                 else{
    //                     gsap.set(this.popupActions,{
    //                         y: '0%'
    //                     })
    //                     this.openMenu()
    
    //                 }
    //             }
    //             //chiudo menu
    //             else {
    //                 // console.log('clicco hamburger e chiudo')
    //                 this.closeMenu()
    //             }
    //         })

    //     })
    // }

    clickItemMenu(){
        //Click sulle voci di menu DESKTOP che aprono un sottomenu
        this.menuItemsWithPrevent.forEach(menuItemWithPrevent => {
            menuItemWithPrevent.addEventListener('click', e => {
                e.preventDefault()
                if(menuItemWithPrevent.classList.contains('active')){
                    gsap.to(this.popupActionsOverlay,{
                        duration: 0.2,
                        opacity: 0
                    })
                    this.closeAllSubmenu()
                    menuItemWithPrevent.classList.remove('active')
                    this.menuItemsWithPrevent.forEach(menuItem => {
                        gsap.to(menuItem, {
                            duration:0.4,
                            opacity: 1
                        })
                    })
                }
                else{
                    this.closeAllSubmenu()
                    this.openSubmenu(menuItemWithPrevent)
                }
            })
        })
        //Click sulle voci di menu MOBILE: prima chiudo il menu, poi faccio partire la transizione (con barba.go). Se la voce cliccata è quella corrente si chiude semplicemente il menu
        this.menuImtemsMobile.forEach(menuItemMobile => {
            menuItemMobile.addEventListener('click', e => {
                if(menuItemMobile.querySelector('a') !== null){
                    if(menuItemMobile.classList.contains('coming-soon'))   {
                        e.preventDefault()
                        return
                    }                 
                    //Se un link porta ad un pdf vado direttamente al link e chiudo solo il menu
                    if(!menuItemMobile.querySelector('a').classList.contains('link-to-document')){
                        e.preventDefault()
                        let a = menuItemMobile.querySelector('a').getAttribute('href')
                        this.closeMenuMobile().then( () => {
                            barba.go(a)
                        })
                    }
                    this.closeSubmenuMobile()
                }
            })
        })

        //Click su icona prenota mobile dentro al menu
        let iconaPrenota = document.querySelector('.container-mobile-menus__header__item.prenota')
        iconaPrenota.addEventListener('click', e => {
        //     // console.log(e)
        //     // e.preventDefault()
        //     let a = iconaPrenota.querySelector('a').getAttribute('href')
            this.closeMenuMobile().then( () => {
        //         barba.go(a)
            })
            this.closeSubmenuMobile()

        })
    }

    openMenu(){
        return new Promise( resolve => {
            this.menu.classList.add('popup-active')
            this.hamburgers.forEach(ham => {
                ham.classList.add('opened')
            })
            // if(isAllMobileDevices){
                this.openHamburgerIcon()
            // }
            this.setZindex()
            //update header elements color
            headerClass.toDefaultColor()
            gsap.to(this.popupActionsBackground,{
                duration: 0.4,
                opacity: 1
            })
            gsap.to(this.menuWrapper,{
                duration: 1,
                opacity: 1,
                delay: 0.3,
                ease: 'power1.in'
            })
            gsap.to(this.menuWrapper,{
                duration: 1,
                y: 0,
                delay: 0.2,
                ease: 'power2.out',
                onComplete: () => {
                    resolve()
                    this.isAnimating = false
                }
            })

        })
    }
    closeMenu(fromAnotherPopup = false){
        return new Promise( resolve => {
            this.hamburgers.forEach(ham => {
                ham.classList.remove('opened')
            })
            this.menu.classList.remove('popup-active')
            if(isAllMobileDevices){
                this.closeHamburgerIcon()
            }
            if(!fromAnotherPopup || fromAnotherPopup === 'minicart'){
                // console.log('not from another popup')
                //Se non viene da un altro popup il closehamburger lo chiamo alla transizione di pagina
                if(fromAnotherPopup === 'minicart'){
                    this.closeHamburgerIcon(fromAnotherPopup)
                }
                gsap.to(this.menuWrapper,{
                    duration: 0.6,
                    opacity: 0,
                    y: 40
                })
                gsap.to(this.popupActionsBackground,{
                    duration: 0.4,
                    opacity: 0,
                    delay: 0.5,
                    onComplete: () => {
                        gsap.set(this.popupActions,{
                            y: '-100%'
                        })
                        this.resetMenu()
                        resolve()
                        this.isAnimating = false
                    }
                })
                //update header elements color
                const bgPageColor = getComputedStyle(document.querySelector('body')).backgroundColor
                if(bgPageColor === colors.panna){
                    headerClass.toAlternativeColor()
                }
                else{
                    headerClass.toDefaultColor()
                } 

            }
            else{
                this.closeHamburgerIcon()
                gsap.to(this.menuWrapper,{
                    duration: 0.6,
                    opacity: 0,
                    y: 40,
                    onComplete: () => {
                        this.resetMenu()
                        resolve()
                        this.isAnimating = false
                    }
                })

            }           
        })
    }

    resetMenu(){
        const duration = 0
        this.closeAllSubmenu(duration)
        this.menuItemsWithPrevent.forEach(menuItem => {
            menuItem.classList.remove('active')
            gsap.set(menuItem, {
                opacity: 1
            })
        })
    }

    closeAllSubmenu(duration = 0.8){
        this.submenus.forEach(submenu => {
            gsap.to(submenu,{
                duration: duration,
                y:30,
                autoAlpha: 0
            })
        })

    }

    openSubmenu(menuItemWithPrevent){
        const dataSubmenu = menuItemWithPrevent.getAttribute('data-submenu')
        const qualeSubmenu = document.querySelector('.right .submenu[data-submenu="'+dataSubmenu+'"]')
        gsap.to(menuItemWithPrevent, {
            duration:0.4,
            opacity: 1
        })
        gsap.to(this.popupActionsOverlay,{
            duration: 0.4,
            opacity: 1
        })
        gsap.to(qualeSubmenu,{
            duration: 0.8,
            y:0,
            ease: 'power2.out'
        })
        gsap.to(qualeSubmenu,{
            duration: 0.8,
            autoAlpha: 1,
            ease: 'power1.in'
        })
        this.menuItemsWithPrevent.forEach(menuItem => {
            if(!menuItem.isSameNode(menuItemWithPrevent)){
                menuItem.classList.remove('active')
                gsap.to(menuItem, {
                    duration:0.4,
                    opacity: 0.4
                })
            }
        })
        menuItemWithPrevent.classList.add('active')

    }


    hoverHamburger(){
        // console.log('hover desk')
        this.hamburgers.forEach(ham => {
            ham.addEventListener('mouseover', () => {
                this.openHamburgerIcon()
            }) 
        })
        this.hamburgers.forEach(ham => {
            ham.addEventListener('mouseleave', () => {
                if(ham.classList.contains('opened')) return
                this.closeHamburgerIcon()
            }) 
        })   
    }
    

    
    // clickHamburgerMobile(){
    //     this.hamburgers.forEach(ham => { 
    //         ham.addEventListener('click', () => {
    //             if(this.isAnimating) return
    //             this.isAnimating = true
    //             //apro menu mobile
    //             if (!ham.classList.contains('opened')) {
    //                 if(document.querySelector('.popup-active') !== null){
    //                     const dataOtherPopup = document.querySelector('.popup-active').getAttribute('data-popup-element')
    //                     if(dataOtherPopup === 'login'){
    //                         loginPopupClass.closeLoginPopup().then( () => {
    //                             this.openMenuMobile()
    //                         })
    //                     }
    //                     else if(dataOtherPopup === 'search'){
    //                         searchClass.closeSearch().then( () => {
    //                             this.openMenuMobile()
    //                         })
    //                     }
    //                 }
    //                 else{
    //                     this.openMenuMobile()
    //                 }
    
    //             }
    //             //chiudo menu mobile
    //             else {
    //                 this.closeMenuMobile()
    //             }
    
    //         })

    //     })  
    // }
    openMenuMobile(){
        return new Promise( resolve => {
            this.hamburgers.forEach(ham => {
                ham.classList.add('opened')
            })
            this.containerMobileMenus.classList.add('menu-mobile-active')  
            this.openHamburgerIcon()      
            //Disattivato dopo che ho spostato l'header feed vino dentro all'header    
            // headerClass.chiudiHeaderFeedVino()
            gsap.set(this.containerMobileMenus,{
                y: '0%'
            })
            this.clipFakeHamburger('clip-partial')
            // gsap.to(this.containerHamburgerFake, {
            //     duration: 0.7,
            //     webkitClipPath:'polygon(0% 0%, 20% 0%, 20% 100%, 0% 100%)', clipPath:'polygon(0% 0%, 20% 0%, 20% 100%, 0% 100%)',
            //     ease: 'power2.inOut'
            // })
            // gsap.to(this.mainMenuBackground,{
            //     duration: 0.4,
            //     autoAlpha: 1
            // })
            gsap.to(this.mainMenuMobileWrapper,{
                duration: 0.8,
                x: '0%',
                ease: 'power2.inOut'
            })
            gsap.to(this.mobileMenusHeader,{
                duration: 0.8,
                x: '0%',
                ease: 'power2.inOut',
                onComplete: () => {                    
                    this.isAnimating = false
                }
            })

        })
    }
    closeMenuMobile(fromAnotherEl = false){
        return new Promise( resolve => {
            this.closeHamburgerIcon()   
            this.containerMobileMenus.classList.remove('menu-mobile-active')
            this.hamburgers.forEach(ham => {
                ham.classList.remove('opened')
            })
            if(!fromAnotherEl && document.querySelector('.page-single-product-vino') !== null){
                headerClass.apriHeaderFeedVino()
            }      
            this.clipFakeHamburger('clip-none')      
            // gsap.to(this.containerHamburgerFake, {
            //     duration: 0.4,
            //     webkitClipPath:'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)', clipPath:'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)',
            //     ease: 'power2.inOut'
            // })
            gsap.to(this.mobileMenusHeader,{
                duration: 0.4,
                x: '105%',
                ease: 'power2.inOut'
            })
            gsap.to(this.mainMenuMobileWrapper,{
                duration: 0.4,
                x: '105%',
                ease: 'power2.inOut'
            })
            gsap.to(this.mainMenuBackground,{
                duration: 0.4,
                autoAlpha: 0,
                onComplete: () => {      
                    gsap.set(this.containerMobileMenus,{
                        y: '-100%'
                    }) 
                    this.isAnimating = false
                    resolve()
                }
            })
           
        })
    }
    openSubmenuMobile(qualeSubmenu){
        // console.log(qualeSubmenu)
        // if(!this.containerSubmenus.classList.contains('one-submenu-is-active')){
            // this.containerSubmenus.classList.add('one-submenu-is-active')
            gsap.set(this.containerSubmenus,{
                y: '0%'
            })
            gsap.to(this.submenuBackground,{
                duration: 0.4,
                autoAlpha: 1
            })            
        // }
        let submenuSelezionato = this.containerMobileMenus.querySelector(`.submenu-mobile[data-submenu="${qualeSubmenu}"]`)
        submenuSelezionato.style.zIndex = 2
        submenuSelezionato.classList.add('opened')
        this.clipFakeHamburger('clip-total')      
        gsap.to(submenuSelezionato, {
            duration: 0.8,
            x: '0%',
            ease: 'power2.inOut',
            onComplete: () => {
                this.isAnimating = false
            }
        })
        this.allSubmenusMobile.forEach(submenuToClose => {
            if(submenuToClose !== submenuSelezionato){
                submenuToClose.style.zIndex = 1
                gsap.to(submenuToClose, {
                    duration: 0.8,
                    x: '105%',
                    ease: 'power2.inOut'
                })
            }
        })
    }
    closeSubmenuMobile(){
        this.clipFakeHamburger('clip-partial') 
        let submenuToClose = this.containerSubmenus.querySelector('.submenu-mobile.opened')
        if(submenuToClose){
            submenuToClose.classList.remove('opened')
            gsap.to(this.submenuBackground,{
                duration: 0.4,
                autoAlpha: 0
            }) 
            gsap.to(submenuToClose, {
                duration: 0.4,
                x: '105%',
                ease: 'power2.inOut',
                onComplete: () => {
                    gsap.set(this.containerSubmenus,{
                        y: '-100%'
                    })  
                    this.isAnimating = false              
                }
            })  
        } 
    }
    clipFakeHamburger(action){
        let clipPath 
        let duration
        if(action === 'clip-total'){
            clipPath = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)'
            duration = 0.4
        }
        else if(action === 'clip-partial'){
            clipPath = 'polygon(0% 0%, 20% 0%, 20% 100%, 0% 100%)'
            duration = 0.7

        }
        else if('clip-none'){
            clipPath = 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)'
            duration = 0.4
            
        }
        // console.log(duration)
        gsap.to(this.containerHamburgerFake, {
            duration,
            webkitClipPath: clipPath, 
            clipPath: clipPath,
            ease: 'power2.inOut'
        })        
    }

    openHamburgerIcon(){
        gsap.to(this.caliceObj, {
            duration: 0.3,
            m1: 20, m2: 15, c1: 30, c2: 50, c3: 70, c4: 50, c5: 80, c6: 15,
            onUpdate: () => {
                this.svgCalice.forEach(svgCalice => {
                    svgCalice.setAttribute('d', `M${this.caliceObj.m1},${this.caliceObj.m2} C${this.caliceObj.c1},${this.caliceObj.c2} ${this.caliceObj.c3},${this.caliceObj.c4} ${this.caliceObj.c5},${this.caliceObj.c6}`)
                })
            }
        })
        gsap.to(this.vinoNelCaliceObj, {
            duration: 0.3,
            m1: 25, m2: 15, c1: 30, c2: 45, c3: 70, c4: 45, c5: 75, c6: 15,
            onUpdate: () => {
                this.svgVinoNelCalice.forEach( svgVinoNelCalice => {
                    svgVinoNelCalice.setAttribute('d', `M${this.vinoNelCaliceObj.m1},${this.vinoNelCaliceObj.m2} C${this.vinoNelCaliceObj.c1},${this.vinoNelCaliceObj.c2} ${this.vinoNelCaliceObj.c3},${this.vinoNelCaliceObj.c4} ${this.vinoNelCaliceObj.c5},${this.vinoNelCaliceObj.c6}`)
                })
            }
        })
        gsap.to(this.gamboObj, {
            duration: 0.3,
            m1: 50, m2: 40, v1: 80,
            onUpdate: () => {
                this.svgGambo.forEach(svgGambo => {
                    svgGambo.setAttribute('d', `M${this.gamboObj.m1},${this.gamboObj.m2} V${this.gamboObj.v1}`)
                })
            }
        })
    }
    
    closeHamburgerIcon(){   
        gsap.to(this.caliceObj, {
            duration: 0.3,
            m1: 0, m2: 25, c1: 30, c2: 50, c3: 70, c4: 50, c5: 100, c6: 25,
            onUpdate: () => {
                this.svgCalice.forEach(svgCalice => {
                    svgCalice.setAttribute('d', `M${this.caliceObj.m1},${this.caliceObj.m2} C30,${this.caliceObj.c2} 70,${this.caliceObj.c4} ${this.caliceObj.c5},${this.caliceObj.c6}`)
                })
            }
        })
        gsap.to(this.vinoNelCaliceObj, {
            duration: 0.3,
            m1: 5, m2: 25, c1: 30, c2: 45, c3: 70, c4: 45, c5: 95, c6: 25,
            onUpdate: () => {
                this.svgVinoNelCalice.forEach( svgVinoNelCalice => {
                    svgVinoNelCalice.setAttribute('d', `M${this.vinoNelCaliceObj.m1},${this.vinoNelCaliceObj.m2} C${this.vinoNelCaliceObj.c1},${this.vinoNelCaliceObj.c2} ${this.vinoNelCaliceObj.c3},${this.vinoNelCaliceObj.c4} ${this.vinoNelCaliceObj.c5},${this.vinoNelCaliceObj.c6}`)
                })
            }
        })
        gsap.to(this.gamboObj, {
            duration: 0.3,
            m1: 50, m2: 50, v1: 50,
            onUpdate: () => {
                this.svgGambo.forEach(svgGambo => {
                    svgGambo.setAttribute('d', `M${this.gamboObj.m1},${this.gamboObj.m2} V${this.gamboObj.v1}`)
                })
            }
        })
    }
}

export {Menu}
